import React, { Component } from 'react';

class IconTicketGrochat extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="47"
                height="27"
                fill="none"
                viewBox="0 0 47 27"
            >
                <path
                    fill="#D81922"
                    d="M35.603 11.874a2.732 2.732 0 00-1.527-.794l.33-1.09s-2.17.72-3.164 2.31a2.498 2.498 0 00-.331.664s0 .019-.019.019a2.795 2.795 0 00-.128.887c0 .776.276 1.46.828 2.014.441.443.956.702 1.527.794l-.331 1.072s2.153-.72 3.165-2.31a2.25 2.25 0 00.33-.665c0-.018.02-.037.02-.037a2.76 2.76 0 00.128-.868c0-.776-.276-1.441-.828-1.996zM12.897 6.885c-1.325 0-2.466.48-3.404 1.423-.938.942-1.417 2.088-1.417 3.418s.479 2.476 1.417 3.418c.938.943 2.08 1.423 3.404 1.423 1.325 0 2.466-.48 3.404-1.422.938-.943 1.417-2.088 1.417-3.419 0-1.33-.479-2.476-1.417-3.418-.938-.942-2.08-1.423-3.404-1.423z"
                ></path>
                <path
                    fill="#D81922"
                    d="M7.211 17.436c-1.564-1.57-2.355-3.474-2.355-5.71 0-.96.147-1.847.442-2.697C1.655 15.292 1.93 22.665 1.93 22.665s2.52-2.125 11.224.35a4.635 4.635 0 003.164-1.404c.939-.942 1.417-2.088 1.417-3.4-1.38 1.072-2.999 1.608-4.82 1.608-2.245-.018-4.14-.813-5.705-2.383z"
                ></path>
                <path
                    fill="#D81922"
                    d="M37.775 18.064c-1.16 1.164-2.54 1.737-4.177 1.737-1.62 0-3.017-.573-4.177-1.737-1.159-1.164-1.73-2.55-1.73-4.194 0-1.626.571-3.03 1.73-4.195 1.16-1.164 2.54-1.737 4.177-1.737 1.638 0 3.018.573 4.177 1.737 1.16 1.164 1.73 2.55 1.73 4.195 0 1.644-.57 3.03-1.73 4.194zM25.76 11.726v8.075h-3.22V3.65h3.22v1.59c1.38-1.072 2.98-1.59 4.82-1.59v3.234c-1.324 0-2.465.48-3.403 1.423-.957.942-1.417 2.088-1.417 3.418zM25.704.751c-8.077-.96-13.395.96-16.91 4.028 1.215-.74 2.577-1.127 4.104-1.127 1.84 0 3.44.536 4.82 1.589V3.65h3.22v14.524c0 2.235-.79 4.12-2.354 5.71-.24.24-.479.461-.736.664.11.037.239.093.35.13 29.88 9.756 28.004-23.097 28.004-23.097S40.48 2.691 25.705.751zM.275 25.861l3.092.425s2.355-3.067 8.28-1.848c-.019 0-7.728-2.9-11.372 1.423z"
                ></path>
            </svg>
        );
    }
}

export default IconTicketGrochat;